/**
 * Copyright (c) 2019-2021 2022 AIGIA All Rights Reserved.
 */

"use strict";

import {Component, EventEmitter, Input, OnChanges, Output} from "@angular/core";
import {FloatingComponent} from "../floating/floating.component";
import {TranslateService} from '@ngx-translate/core';

/**
 * todo
 */
@Component({
	selector: "aigia-ballistic-tab",
	templateUrl: "./ballistic-tab.component.html",
	styleUrls: ["../floating/floating.component.css", "./ballistic-tab.component.css"],
})
export class BallisticTabComponent extends FloatingComponent implements OnChanges {

	constructor(
		public translate: TranslateService
	) {
		super();
	}

	@Input() public locked: boolean;
	@Input() public shots: any;
	@Input() public size: number[];
	@Input() public style: any;

	public hasData: boolean = false;
	public title: string = "Ballistic Table";

	public dataSource: any = {};

	@Output() public progrssChange = new EventEmitter<boolean>();

	/**
	 * @returns none
	 */
	public ngOnChanges(changes: any): void {
		Object.keys(changes).forEach((propName) => {
			switch (propName) {
				case "visible":
				case "shots":
					if (this.visible) {
						this.draw(this.shots);
					}
					break;
				case "fontsize":
					if (changes.fontsize.currentValue) {
						const size: string = changes.fontsize.currentValue;
						this.style = {"font-size": size};
					}
					break;
				default:
					break;
			}
		});
	}

	/**
	 * @returns
	 */
	public name(source: any): string {
		let result = "";
		if (source) {
			result = source.Name;
		}
		return result;
	}

	/**
	 * @returns
	 */
	public value(source: any): number {
		let result = 0;
		if (source) {
			result = source.Value;
		}
		return result;
	}

	/**
	 * @returns
	 */
	public unit(source: any): string {
		let result = "";
		if (source) {
			if (source.Unit) {
				result = "(" + source.Unit + ")";
			}
		}
		return result;
	}

	/**
	 * todo
	 */
	public itemTitle(index: number): any {
		if (this.dataSource && this.dataSource.table && this.dataSource.table[index]) {
			return this.name(this.dataSource.table[index]) + this.unit(this.dataSource.table[index]);
		}
		return '';

	}

	/**
	 * todo
	 */
	public itemValue(index: number): any {
		if (this.dataSource && this.dataSource.table && this.dataSource.table[index]) {
			return this.value(this.dataSource.table[index]);
		}
		return 0;

	}

	/**
	 * @returns none
	 */
	public draw(shots: any): void {
		this.Progress(true);
		try {
			//	const dataSources: any[] = [];
			this.hasData = false;
			if (shots.length > 0) {
				//	shots.forEach((shot: any): void => {
				const shot = shots[0];
				if (shot.prizm) {
					this.hasData = true;
					this.dataSource = {name: shot.name, table: shot.prizm.DataList};
				}
				//	})
			}
			//	this.dataSources = dataSources;
		} finally {
			this.Progress(false);
		}
	}

	/**
	 * @returns none
	 */
	public Truncate(value: string, start: number, limit: number): string {
		return value.substring(start, limit);
	}

	/**
	 * @returns none
	 */
	public Progress(progress: boolean): void {
		this.progrssChange.emit(progress);
	}

	/**
	 * @returns style
	 */
	public maxSize(): any {
		return {height: "fit-content", width: this.size[0] + "px"};
	}

	/**
	 * todo
	 */
	public shotName(index: number): string {
		return "Shot " + (index + 1);
	}

}
